import React, { Component } from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { setProdSelc } from './../redux/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class Montagem extends Component {

  state = {
    sel: "true",
    qtd: 0,
    qtdSel: 0,
    select: [],
    prod: {}
  }

  selecionados = {

  }

  sec = [];

  constructor(props) {
    super(props);
    var obb = Object.entries(this.props.Iten.itens);

    for (var j = 0; j < obb.length; j++) {
      this.selecionar(obb[j][1].id, false)
    }
  }

  async componentDidMount() {
    // Começamos com uma cópia do objeto 'produto' do Redux
    var listTemp = this.props.preodSelc.produto;

    // Garantir que a propriedade motagem existe e inclui este grupo
    if (!Array.isArray(listTemp.motagem)) {
      listTemp.motagem = [];
    }
    
    // Adiciona este grupo à lista de montagem se ainda não estiver lá
    if (!listTemp.motagem.includes(this.props.Iten.nome)) {
      listTemp.motagem.push(this.props.Iten.nome);
    }

    // Obtemos a lista de itens específica para este componente
    var list = listTemp[this.props.Iten.nome];

    // Verificação de Segurança:
    if (!Array.isArray(list)) {
      list = [];
    }

    // Agora que temos a garantia de que 'list' é um array, podemos usar .splice() sem erros.
    list.splice(0, list.length);

    // Atualizamos o objeto temporário com a lista (agora vazia)
    listTemp = { ...listTemp, [this.props.Iten.nome]: list };
    this.props.setProdSelc(listTemp);

    console.log('Montagem componentDidMount - Grupo:', this.props.Iten.nome, 'Produto:', listTemp);

    // Mapeia os itens para marcar o primeiro, se obrigatório
    this.props.Iten.itens.map((i, ix) => (
      this.props.Iten.obriga === 'Sim' && ix === 0 ? this.marcarPrimeiro(i) : null
    ));
  }

  selecionar(title, filter) {
    if (this.selecionados[title] !== undefined) { // Testa se a chave existe
      this.state[title].push(filter);    // Adiciona um elemento no array
    } else {
      this.state[title] = filter;      // Se não existe, cria um array com um elemento
    }
  }


  render() {
    return (
      <div style={{ 
        marginBottom: 24,
        padding: '20px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        borderRadius: 16,
        border: '1px solid rgba(165, 42, 42, 0.1)',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
      }}>
        <div style={{ width: '100%', marginBottom: 16 }}>
          <label style={{ 
            fontSize: 18, 
            fontWeight: "bold", 
            width: '100%',
            color: '#333',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}>
            {this.props.Iten.nome} 
            {this.props.Iten.obriga === 'Sim' ? 
              <span style={{ 
                color: '#a52a2a', 
                fontSize: 20,
                fontWeight: 'bold',
              }}>*</span> 
              : null
            }
          </label>
        </div>

        <div style={{ marginBottom: 16 }}>
          {this.props.Iten.quantidade > 1 ?
            <label style={{ 
              fontSize: 13, 
              color: '#666',
              fontStyle: 'italic',
              padding: '6px 12px',
              background: 'rgba(165, 42, 42, 0.1)',
              borderRadius: 20,
              display: 'inline-block',
            }}>
              Selecione até {this.props.Iten.quantidade} opções
            </label> :
            <label style={{ 
              fontSize: 13, 
              color: '#666',
              fontStyle: 'italic',
              padding: '6px 12px',
              background: 'rgba(165, 42, 42, 0.1)',
              borderRadius: 20,
              display: 'inline-block',
            }}>
              Selecione apenas 1 opção
            </label>
          }
        </div>

        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 8,
        }}>
          {this.props.Iten.itens.map((i, ix) => (
            <div 
              key={ix}
              style={{ 
                padding: '16px',
                background: this.state[i.id] ? 
                  'linear-gradient(135deg, #a52a2a 0%, #8b0000 100%)' : 
                  '#fff',
                borderRadius: 12,
                border: this.state[i.id] ? 
                  '2px solid #a52a2a' : 
                  '1px solid rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: this.state[i.id] ? 
                  '0 4px 16px rgba(165, 42, 42, 0.3)' : 
                  '0 2px 8px rgba(0,0,0,0.05)',
                transform: this.state[i.id] ? 'translateY(-2px)' : 'translateY(0)',
              }}
              onClick={async () => {
                if (this.state[i.id]) {
                  if (this.props.Iten.obriga === 'Sim' && this.sec.length === 1) { console.log("aqui") }
                  else {
                    const { setProdSelc } = this.props;
                    var listTemp = this.props.preodSelc.produto;
                    var listTemp2 = this.props.preodSelc.produto[this.props.Iten.nome];
                    // Programação defensiva para garantir array
                    if (!Array.isArray(listTemp2)) {
                      listTemp2 = [];
                    }
                    listTemp2 = listTemp2.filter((element) => element != i.nome)
                    this.sec = this.removerPorId2(this.sec, i.id);
                    var pTemp = parseFloat(listTemp.preco) - parseFloat(i.preco)
                    listTemp = { ...listTemp, preco: pTemp }
                    setProdSelc(listTemp);
                    listTemp = { ...listTemp, [this.props.Iten.nome]: listTemp2 }
                    this.props.preodSelc.produto = listTemp
                    setProdSelc(listTemp);
                    this.setState({ [i.id]: !this.state[i.id], qtd: this.state.qtd - 1, qtdSel: this.state.qtdSel - 1 })
                    //this.getValorMenos();
                  }
                  this.getValor();
                } else {
                  if (this.state.qtd < this.props.Iten.quantidade) {
                    const { setProdSelc } = this.props;
                    var listTemp = this.props.preodSelc.produto;
                    var listTemp2 = this.props.preodSelc.produto[this.props.Iten.nome];
                    // Programação defensiva para garantir array
                    if (!Array.isArray(listTemp2)) {
                      listTemp2 = [];
                    }
                    listTemp2.push(i.nome);
                    var pTemp = parseFloat(listTemp.preco) + parseFloat(i.preco)
                    listTemp = { ...listTemp, preco: pTemp }
                    this.sec.push(i);
                    listTemp = { ...listTemp, [this.props.Iten.nome]: listTemp2 }
                    setProdSelc(listTemp);
                    this.setState({ [i.id]: !this.state[i.id], qtd: this.state.qtd + 1, qtdSel: this.state.qtdSel + 1 });
                    this.getValor();
                  } else {
                    if (this.props.Iten.obriga === 'Sim' && this.props.Iten.quantidade === "1") {
                      this.props.Iten.itens.map((j, ix) => (
                        this.desmarcarAll(j)
                      ));
                      const delay = ms => new Promise(res => setTimeout(res, ms));
                      await delay(8);
                      this.marcar(i)
                    } else if (this.props.Iten.obriga === 'Sim' && this.props.Iten.quantidade !== "1") {
                      const delay = ms => new Promise(res => setTimeout(res, ms));
                      //await delay(8);
                      //this.marcar(i)
                    }
                  }
                }
              }}
            >
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                width: '100%',
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ 
                    fontSize: 15, 
                    fontWeight: 'bold',
                    color: this.state[i.id] ? '#fff' : '#333',
                    marginBottom: 4,
                    lineHeight: 1.4,
                  }}>
                    {i.nome.split("@")[1]}
                  </div>
                  <div style={{ 
                    fontSize: 16, 
                    fontWeight: 'bold',
                    color: this.state[i.id] ? '#fff' : '#a52a2a',
                    marginBottom: 4,
                  }}>
                    € {this.mascaraValor(eval(parseFloat(i.preco)).toFixed(2))}
                  </div>
                  {i.obs && (
                    <div style={{ 
                      fontSize: 12, 
                      color: this.state[i.id] ? 'rgba(255,255,255,0.8)' : '#666',
                      lineHeight: 1.3,
                    }}>
                      {i.obs}
                    </div>
                  )}
                </div>
                <div style={{ 
                  marginLeft: 16,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: this.state[i.id] ? 
                    'rgba(255,255,255,0.2)' : 
                    'rgba(165, 42, 42, 0.1)',
                  transition: 'all 0.3s ease',
                }}>
                  {this.state[i.id] ?
                    <CheckCircleOutlineIcon style={{ 
                      fontSize: 20, 
                      color: '#fff'
                    }} />
                    : <div style={{
                        width: 16,
                        height: 16,
                        borderRadius: '50%',
                        border: '2px solid #a52a2a',
                        background: 'transparent',
                      }} />
                  }
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  async marcarPrimeiro(i) {
    const delay = ms => new Promise(res => setTimeout(res, ms));

    await delay(8);
    this.marcar(i)
    // if (this.state[i.id]) { }
    // else {

    //   const { setProdSelc } = this.props;
    //   var listTemp = this.props.preodSelc.produto;
    //   var listTemp2 = this.props.preodSelc.produto[this.props.Iten.nome];
    //   listTemp2.push(i.nome);
    //   var pTemp = parseFloat(listTemp.preco)
    //   listTemp = { ...listTemp, preco: pTemp }
    //   //setProdSelc(listTemp);

    //   this.sec.push(i);

    //   listTemp = { ...listTemp, [this.props.Iten.nome]: listTemp2 }
    //   //setProdSelc(listTemp);

    //   this.setState({ [i.id]: !this.state[i.id], qtd: this.state.qtd + 1, qtdSel: this.state.qtdSel + 1 });
    //   //this.getValor();

    //   var PrecoTT = 0;
    //   var PrecoMM = 0;
    //   var PrecoMD = 0;
    //   var Qtd = 0;

    //   for (var i = 0; i < Object.entries(this.sec).length; i++) {
    //     PrecoTT = PrecoTT + parseFloat(this.sec[i].preco);
    //     Qtd = Qtd + 1;
    //     if (this.sec[i].preco > PrecoMM) {
    //       PrecoMM = this.sec[i].preco;
    //     }
    //     console.log('Valor: ', this.sec[i].preco)
    //   }

    //   PrecoMD = PrecoTT / Qtd;

    //   PrecoMD = (PrecoMD).toFixed(2);

    //   if (this.props.Iten.tipoPreco == 'Maior') {
    //     console.log('Maior')
    //     var pTemp = parseFloat(listTemp.preco) + parseFloat(PrecoMM);
    //     listTemp = { ...listTemp, preco: pTemp }
    //     setProdSelc(listTemp);
    //   } else if (this.props.Iten.tipoPreco == 'Divisão') {
    //     console.log('Divisão')
    //     var pTemp = parseFloat(listTemp.preco) + parseFloat(PrecoMD);
    //     listTemp = { ...listTemp, preco: pTemp }
    //     setProdSelc(listTemp);
    //   } else {
    //     console.log('Normal')        
    //     var pTemp = parseFloat(listTemp.preco) + parseFloat(PrecoTT);
    //     console.log('preco1', PrecoTT)
    //     console.log('preco2', listTemp.preco)
    //     console.log('resilt', pTemp)

    //     listTemp = { ...listTemp, preco: pTemp }

    //     setProdSelc(listTemp);
    //   }
    // }

  }

  desmarcarAll(i) {
    if (this.state[i.id]) {
      const { setProdSelc } = this.props;
      var listTemp = this.props.preodSelc.produto;
      var listTemp2 = this.props.preodSelc.produto[this.props.Iten.nome];

      listTemp2.splice(i.nome, 1);

      this.sec = this.removerPorId2(this.sec, i.id);

      var pTemp = parseFloat(listTemp.preco) - parseFloat(i.preco)
      listTemp = { ...listTemp, preco: pTemp }
      //setProdSelc(listTemp);

      listTemp = { ...listTemp, [this.props.Iten.nome]: listTemp2 }
      //setProdSelc(listTemp);

      this.setState({ [i.id]: false, qtd: this.state.qtd - 1, qtdSel: 0 })
      //this.getValor();

      var PrecoTT = 0;
      var PrecoMM = 0;
      var PrecoMD = 0;
      var Qtd = 0;

      for (var i = 0; i < Object.entries(this.sec).length; i++) {
        PrecoTT = PrecoTT + parseFloat(this.sec[i].preco);
        Qtd = Qtd + 1;
        if (this.sec[i].preco > PrecoMM) {
          PrecoMM = this.sec[i].preco;
        }
        console.log('Valor: ', this.sec[i].preco)
      }

      PrecoMD = PrecoTT / Qtd;

      PrecoMD = (PrecoMD).toFixed(2);

      //var listTemp = this.props.preodSelc.produto;


      if (this.props.Iten.tipoPreco == 'Maior') {
        var pTemp = parseFloat(listTemp.preco) - parseFloat(PrecoMM);
        listTemp = { ...listTemp, preco: pTemp }
        setProdSelc(listTemp);
      } else if (this.props.Iten.tipoPreco == 'Divisão') {
        console.log('Divisão')
        var pTemp = parseFloat(listTemp.preco) - parseFloat(PrecoMD);
        listTemp = { ...listTemp, preco: pTemp }
        setProdSelc(listTemp);
      } else {
        var pTemp = parseFloat(listTemp.preco) - parseFloat(PrecoTT);
        console.log('Normal, preco: ', pTemp)
        listTemp = { ...listTemp, preco: pTemp }
        setProdSelc(listTemp);
      }
    }

  }

  marcar(i) {
    if (this.state[i.id]) { }
    else {
      const { setProdSelc } = this.props;
      var listTemp = this.props.preodSelc.produto;
      var listTemp2 = this.props.preodSelc.produto[this.props.Iten.nome];
      listTemp2.push(i.nome);
      var pTemp = parseFloat(listTemp.preco) + parseFloat(i.preco)


      listTemp = { ...listTemp, preco: pTemp }

      console.log('item inserido', i)
      this.sec.push(i);

      listTemp = { ...listTemp, [this.props.Iten.nome]: listTemp2 }
      console.log('lista após inserir', listTemp)
      setProdSelc(listTemp);

      this.setState({ [i.id]: !this.state[i.id], qtd: this.state.qtd + 1, qtdSel: this.state.qtdSel + 1 });
      this.getValor();
    }
  }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor
  }


  async getValor() {
    var PrecoTT = 0;
    var PrecoMM = 0;
    var PrecoMD = 0;
    var Qtd = 0;

    for (var i = 0; i < Object.entries(this.sec).length; i++) {
      PrecoTT = PrecoTT + parseFloat(this.sec[i].preco);
      Qtd = Qtd + 1;
      if (this.sec[i].preco > PrecoMM) {
        PrecoMM = parseFloat(this.sec[i].preco);
      }

    }

    PrecoMD = PrecoTT / Qtd;
    const { setProdSelc } = this.props;
    var listTemp = this.props.preodSelc.produto;
    if (listTemp.simples = 'Sim') {
      listTemp.arrPreco[9999] = parseFloat(listTemp.precoUn)
      
    }
    if (this.props.Iten.tipoPreco == 'Maior') {
      var pTemp = parseFloat(listTemp.precoUn) + this.getVlList(this.props.Key) + PrecoMM;
      listTemp.arrPreco[this.props.index] = PrecoMM
      listTemp.preco = listTemp.arrPreco.reduce((a, b) => a + b)
      setProdSelc(listTemp);
      console.log('prod maior', listTemp)

      await setProdSelc(listTemp);
    } else if (this.props.Iten.tipoPreco == 'Divisão') {
      var pTemp = parseFloat(listTemp.precoUn) + this.getVlList(this.props.Key) + PrecoMD;
      listTemp.arrPreco[this.props.index] = PrecoMD
      listTemp.preco = listTemp.arrPreco.reduce((a, b) => a + b)
      setProdSelc(listTemp);
      console.log('prod div', listTemp)
    } else {
      var pTemp = parseFloat(listTemp.precoUn) + this.getVlList(this.props.Key) + PrecoTT;
      listTemp.arrPreco[this.props.index] = PrecoTT
      listTemp.preco = listTemp.arrPreco.reduce((a, b) => a + b)
      setProdSelc(listTemp);
      console.log('prod normal', listTemp)
    }




  }

  getVlList(list) {
    var Exit = 0;

    if (this.props.Key !== 0) {
      Exit = Exit + this.props.preodSelc.produto.zero;
    }

    if (this.props.Key !== 1) {
      Exit = Exit + this.props.preodSelc.produto.um;
    }

    if (this.props.Key !== 2) {
      Exit = Exit + this.props.preodSelc.produto.dois;
    }

    if (this.props.Key === 3) {
      Exit = Exit + this.props.preodSelc.produto.tres;
    }

    if (this.props.Key === 4) {
      Exit = Exit + this.props.preodSelc.produto.quatro;
    }

    if (this.props.Key === 5) {
      Exit = Exit + this.props.preodSelc.produto.cinco;

    }

    if (this.props.Key === 6) {
      Exit = Exit + this.props.preodSelc.produto.seis;
    }


    return Exit;

  }

  getNome(num) {
    var Exit = "zero"

    if (num === 1) {
      Exit = "um"
    }

    if (num === 2) {
      Exit = "dois"
    }

    if (num === 3) {
      Exit = "tres"
    }

    if (num === 4) {
      Exit = "quatro"
    }

    if (num === 5) {
      Exit = "cinco"
    }

    if (num === 6) {
      Exit = "seis"
    }

    if (num === 7) {
      Exit = "sete"
    }

    return Exit
  }

  getValorMenos() {
    var PrecoTT = 0;
    var PrecoMM = 0;
    var PrecoMD = 0;
    var Qtd = 0;

    for (var i = 0; i < Object.entries(this.sec).length; i++) {
      PrecoTT = PrecoTT + parseFloat(this.sec[i].preco);
      Qtd = Qtd + 1;
      if (this.sec[i].preco > PrecoMM) {
        PrecoMM = this.sec[i].preco;
      }
    }
    PrecoMD = PrecoTT / Qtd;

    PrecoMD = (PrecoMD).toFixed(2);
    const { setProdSelc } = this.props;
    var listTemp = this.props.preodSelc.produto;

    if (this.props.Iten.tipoPreco == 'Maior') {
      var pTemp = parseFloat(PrecoMM);
      listTemp = { ...listTemp, preco: pTemp }
      setProdSelc(listTemp);
    } else if (this.props.Iten.tipoPreco == 'Divisão') {
      var pTemp = parseFloat(listTemp.preco) - parseFloat(PrecoMD);
      listTemp = { ...listTemp, preco: pTemp }
      setProdSelc(listTemp);
    } else {
      var pTemp = parseFloat(listTemp.preco) - parseFloat(PrecoTT);
      listTemp = { ...listTemp, preco: pTemp }
      setProdSelc(listTemp);
    }


  }

  removerPorId2(array, id) {
    return array.filter(function (el) {
      return el.id !== id;
    });
  }

  QuantSel(array) {
    var e = 0;
    array.filter(function (el) {
      console('czxcz', el)
    });
  }
}

const mapStateToProps = state => ({
  preodSelc: state.SelecReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setProdSelc }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Montagem);
